import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

// EN-5191: this is a module constant, not a component, so the headers resolve through the
// i18next singleton rather than a hook. Each `header` is a thunk evaluated at render time, so
// it picks up whatever language is in force then.
export const myTasksColumns = [
  createColumn({
    keyName: "patient",
    header: () => i18next.t("myTasks_columns_patient"),
    cell: (info) => info.renderValue(),
    size: 130,
  }),
  createColumn({
    keyName: "notes",
    header: () => i18next.t("myTasks_columns_note"),
    cell: (info) => info.renderValue(),
    size: 280,
  }),
  createColumn({
    keyName: "time",
    header: () => i18next.t("myTasks_columns_added"),
    cell: (info) => info.renderValue(),
    size: 130,
  }),
  createColumn({
    keyName: "complete",
    header: () => i18next.t("myTasks_columns_complete"),
    cell: (info) => info.renderValue(),
    size: 130,
  }),
  createColumn({
    keyName: "priority",
    header: () => i18next.t("myTasks_columns_priority"),
    cell: (info) => info.renderValue(),
    size: 90,
  }),
  createColumn({
    keyName: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 30,
  }),
];
